"use client";

import { c as _c } from "react/compiler-runtime";
import { storedAttributeProps } from "../html-attributes";
import { NodeViewWrapper } from "@tiptap/react";
import { cx } from "@/lib/tailwind-utils";
import type { DividerAttrs } from "./definition";
import { getDividerStyles } from "./styles";
interface Props {
  attrs: DividerAttrs;
  updateAttrs: (attrs: Partial<DividerAttrs>) => void;
  selected: boolean;
}
export function DividerTiptapView(t0) {
  const $ = _c(10);
  const {
    attrs,
    selected
  } = t0;
  const t1 = selected && "ring-2 ring-primary/30 rounded";
  let t2;
  if ($[0] !== t1) {
    t2 = cx(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== attrs) {
    t3 = storedAttributeProps(attrs);
    $[2] = attrs;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== attrs) {
    t4 = getDividerStyles(attrs);
    $[4] = attrs;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <NodeViewWrapper data-block-type="emailDivider" contentEditable={false}><hr className={t2} {...t3} style={t4} /></NodeViewWrapper>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}